/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export type ReplayIconProps = {
  color?: string;
  size?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) Replay Icon component.
 */
export const ReplayIcon = ({size = 20, color = dlsColor('grey3')}: ReplayIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill='none'>
      <path d="M12 5V2.21c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01-.07-.48-.49-.85-.98-.85-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24C20.84 9.48 16.94 5 12 5z" fill={color} />
    </svg>
  );
};

export default ReplayIcon;
